export default __webpack_public_path__ + "static/media/iridescent.cf528fce.png";